if (!customElements.get("m-custom-home-banner")) {
  class MCustomHomeBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5;
      this.sliderContainer = this.querySelector(".swiper-container");
      this.lastActive = null;

      if (!this.sliderContainer || this.sliderContainer.querySelectorAll(".swiper-slide").length < 1) {
        return;
      }

      this.initSlider();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    initSlider() {
      const slideCount = this.sliderContainer.querySelectorAll(".swiper-slide").length;
      const enableLoop = slideCount > 1;

      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        autoplay: this.autoplay && enableLoop
          ? {
              delay: this.autoplaySpeed * 1000,
              disableOnInteraction: true,
            }
          : false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        loop: enableLoop,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      if (Number.isNaN(index) || !this.slider) return;

      this.lastActive = index;
      if (this.slider.params.loop) {
        this.slider.slideToLoop(index);
      } else {
        this.slider.slideTo(index);
      }
    }
  }

  customElements.define("m-custom-home-banner", MCustomHomeBanner);
}